import { Reducer } from 'redux';
import { OrderActionTypes, OrderState } from './type';

const initialState: OrderState = {
  detail: {},
  reportList: [],
  list: {
    currentPage: 0,
    totalPage: 0,
    data: []
  },
}

const reducer: Reducer<OrderState> = (state = initialState, action) => {
  switch (action.type) {
    case OrderActionTypes.FETCH_ORDER_LIST_SUCCESS: {
      const { data, totalPage, currentPage } = action;
      if (currentPage === 1) {
        return {
          ...state,
          list: {
            data,
            totalPage,
            currentPage
          }
        }
      }
      return {
        ...state,
        list: {
          data: [...state.list.data, ...data],
          totalPage,
          currentPage
        }
      }
    }
    case OrderActionTypes.FETCH_ORDER_DETAIL_SUCCESS: {
      const { data } = action;
      return {
        ...state,
        detail: data
      }
    }
    case OrderActionTypes.FETCH_REPORT_ORDER_LIST_SUCCESS: {
      const { data } = action;
      return {
        ...state,
        reportList: data
      }
    }
    case OrderActionTypes.CLEAR_ORDER_DETAIL: {
      return {
        ...state,
        detail: {}
      }
    }
    default: {
      return state
    }
  }
}

export { reducer as OrderReducer };